// extracted by mini-css-extract-plugin
module.exports = {"container":"_2rV7t_Fpcrhj6S-wYmApCu","field":"_3PFrZvUjlORV7-TCYEJ5D3","newPriceFields":"_27HuxooMQnhphEzU9qQggf","pricesList":"rD2xx9kOqCtIWZkwG7jHD"};